<template>
    <v-row>
      <v-col cols="12">
          <sale-per-month-card> </sale-per-month-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import SalePerMonthCard from "@/components/report/SalePerMonthCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Sales Per Month",
    },
  
    components: {
       SalePerMonthCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>